import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {
    OrderGuideServiceProxy,
    ArticleServiceProxy,
    ArticleDto,
    PagedResultDtoOfArticleDto,
    FieldTypes
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import moment from 'moment';

import { SearchAndSelectComponent } from
    '@app/shared/common/shop-system/common/search-and-select/search-and-select.component';
import { ColumnDefinition } from '@app/shared/common/shop-system/models/models';
import { IColumnDefinition } from '@app/shared/common/shop-system/models/models';

@Component({
    selector: 'app-shop-search-and-select-articles',
    templateUrl: './search-and-select-articles.component.html',
    styleUrls: ['./search-and-select-articles.component.less']
})
export class SearchAndSelectArticlesComponent extends AppComponentBase implements OnInit {

    //#region initialization Basic SearchAndSelectComponent
    //create dynamic SearchAndSelectComponent depends on Provided type
    private _searchAndSelectArticle: SearchAndSelectComponent<ArticleDto>;
    @ViewChild('appSearchAndSelectComponent')
    set searchAndSelectArticle(value: SearchAndSelectComponent<ArticleDto>) {
        this._searchAndSelectArticle = value;
        //set instance of class to define which property he need s to show
        this._searchAndSelectArticle.instance = ArticleDto.fromJS({});
        //set specific property to show that overrides default columns depends on instance of provided Class(Type)

        let columns: ColumnDefinition[] = [
            { field: 'code', header: 'code', sorting: true, colWidth: '10em', type: FieldTypes.Text },
            { field: 'code', header: 'image', sorting: false, colWidth: '10em', height: 68, type: 10 },
            { field: 'title', header: 'title', sorting: true, type: FieldTypes.Text }

            //{ field: 'creationTime', header: 'Date', type: FieldTypes.Date }
        ];
        this._searchAndSelectArticle.columns = columns;
    }
    //#endregion

    @Input() orderGuideId: string;

    @Output() onChangeArticles: EventEmitter<any> = new EventEmitter<any>();

    selectedArticles: ArticleDto[] = [];

    private _articles: ArticleDto[] = [];
    set articles(value: ArticleDto[]) {
        if (!value) {
            this._articles = [];
        }

        this._articles = value;
    }
    get articles(): ArticleDto[] {
        return this._articles;
    }


    private _total: number = 0;
    set total(value: number) {
        if (!value) {
            this._total = 0;
        }

        this._total = value;
    }
    get total(): number {
        return this._total;
    }


    private _searchString: string;
    set searchString(value: string) {
        this._searchString = value;
    }
    get searchString():string {
        return this._searchString;
    }

    get excludeOrderGuideId(): string {
        return this.orderGuideId;
    }

    id: string;

    constructor(
        injector: Injector,
        private _orderGuideServiceProxy: OrderGuideServiceProxy,
        private _articleServiceProxy: ArticleServiceProxy,
        private _activatedRoute: ActivatedRoute
    ) {
        super(injector);


        this.id = this._activatedRoute.snapshot.params['id'];
    }

    ngOnInit(): void {
        this.getArticles();
    }

    onSearchChange(searchString: string) {
        this.searchString = searchString;
        this.getArticles();
    }

    getArticles() {
        if (this._searchAndSelectArticle) {
            this._searchAndSelectArticle.primengTableHelper.showLoadingIndicator();
            this._articleServiceProxy.getFilteredArticles(
                this.searchString || undefined,
                this.id || undefined,
                    undefined,
                    undefined,
                    undefined, 0, 10)
                .subscribe((articles: PagedResultDtoOfArticleDto) => {
                    this.articles = articles.items;
                    this.total = articles.totalCount;

                    this._searchAndSelectArticle.primengTableHelper.records = articles.items;
                    this._searchAndSelectArticle.primengTableHelper.totalRecordsCount = articles.totalCount;

                    this._searchAndSelectArticle.primengTableHelper.hideLoadingIndicator();
                });
        }
    }

    onPagination(pagination) {
        if (this._searchAndSelectArticle) {
           this._searchAndSelectArticle.primengTableHelper.showLoadingIndicator();
           this._articleServiceProxy.getFilteredArticles(
               this.searchString || undefined,
               this.id || undefined,
               undefined,
                   undefined,
                   pagination.sorting || undefined,
                   pagination.skipCount || 0,
                   pagination.maxResultCount || 10)
               .subscribe((articles: PagedResultDtoOfArticleDto) => {
                   this.articles = articles.items;
                   this.total = articles.totalCount;

                   this._searchAndSelectArticle.primengTableHelper.records = articles.items;
                   this._searchAndSelectArticle.primengTableHelper.totalRecordsCount = articles.totalCount;

                   this._searchAndSelectArticle.primengTableHelper.hideLoadingIndicator();

               });
       }
    }

    onRowSelect($event) {
        this.onChangeArticles.emit($event);
    }
    onRowUnselect($event) {
        this.onChangeArticles.emit($event);
    }

}
